import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import EstimateWidget from "@/components/landing/EstimateWidget";
import Philosophy from "@/components/landing/Philosophy";
import Services from "@/components/landing/Services";
import TrustValues from "@/components/landing/TrustValues";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-white text-[#0A0A0A] font-body" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <EstimateWidget />
        <Philosophy />
        <Services />
        <TrustValues />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
